import themes from '@/themes';
import components from './docs/data/components';
import { folders } from './docs/data/structures';
import { sleep } from './commons';

const defaultValues = {
    quickbar: {
        open: false,
        view: null,
        options: {
            title: null,
            icon: null,
            width: 320,
            overlay: true,
            autoclose: true
        }
    },
};

export default {
    namespaced: true,

    state: {
        theme: themes,

        themes,

        message: {
            alert: {
                title: 'message.alert.title',
                text: null,
                visible: false,
                resolve: null,
            },
            alertMultiples: {
                title: 'message.alert.title',
                text: null,
                visible: false,
                resolve: null,
            },
            confirm: {
                title: 'message.confirm.title',
                text: null,
                visible: false,
                resolve: null,
            },
            notify: {
                text: null,
                visible: false,
                color: 'success',
                timeout: 2000
            },
        },

        sidebar: {
            open: false,
        },

        quickbar: {
            ...defaultValues.quickbar
        },

        pageView: {
            activeTab: null,
            tabs: []
        },

        messenger: {
            window: 0,
        },

        docs: {
            components,
            folders,
        },
    },

    mutations: {
        SET_THEME(state, theme) {
            state.theme = theme;
        },
        ALERT(state, msg) {
            if (!state.message.alert.resolve) {
                if (typeof msg === 'object') {
                    return state.message.alert = { 
                        title: msg.title || 'message.alert.title',
                        text: msg.text,
                        resolve: msg.resolve,
                        visible: true
                    };
                }
                state.message.alert.text = msg.text;
                state.message.alert.resolve = msg.resolve;
                state.message.alert.visible = true;
            }
            state.message.alert.resolve(msg);
            state.message.alert = { 
                title: 'message.alert.title',
                text: null,
                resolve: null,
                visible: false
            };
        },
        ALERTMULTIPLES(state, msg) {
            if (!state.message.alertMultiples.resolve) {
                if (typeof msg === 'object') {
                    return state.message.alertMultiples = { 
                        title: msg.title || 'message.alert.title',
                        text: msg.text,
                        resolve: msg.resolve,
                        visible: true,
                    };
                }
                state.message.alertMultiples.text =  messages;
                state.message.alertMultiples.resolve = msg.resolve;
                state.message.alertMultiples.visible = true;
            }
            state.message.alertMultiples.resolve(msg);
            state.message.alertMultiples = { 
                title: 'message.alert.title',
                text: null,
                resolve: null,
                visible: false,
            };
        },
        CONFIRM(state, msg) {
            if (!state.message.confirm.resolve) {
                if (typeof msg === 'object') {
                    return state.message.confirm = { 
                        title: msg.title || 'message.confirm.title',
                        text: msg.text,
                        resolve: msg.resolve,
                        visible: true
                    };
                }
                state.message.confirm.text = msg.text;
                state.message.confirm.resolve = msg.resolve;
                state.message.confirm.visible = true;
            }
            state.message.confirm.resolve(msg);
            state.message.confirm = { 
                title: 'message.confirm.title',
                text: null,
                resolve: null,
                visible: false
            };
        },
        NOTIFY(state, msg) {
            if (typeof msg === 'object') {
                return state.message.notify = {
                    ...state.message.notify,
                    ...msg
                };
            }
            state.message.notify.text = msg;
            state.message.notify.visible = true;
        },
        SIDEBAR_TOGGLE(state) {
            state.sidebar.open = !state.sidebar.open;
        },
        QUICKBAR_TOGGLE(state, open) {
            state.quickbar.open = open !== undefined ? open : !state.quickbar.open;
        },
        QUICKBAR_OPEN(state, payload) {
            if (!payload || !payload.view) {
                return console.log('[X] Informe o nome do componente a ser renderizado na quickbar.');
            }
            if (payload.options) {
                state.quickbar.options = {...state.quickbar.options, ...payload.options };
            }
            state.quickbar.view = payload.view;
            state.quickbar.open = true;
        },
        QUICKBAR_RESET(state) {
            sleep(300).then(() => {
                state.quickbar = { ...defaultValues.quickbar };
            });
        },
        SET_MESSENGER_WINDOW(state, window) {
            state.messenger.window = window;
        },
        NEW_TAB(state, tab) {
            state.pageView.tabs.push(tab);
        },
        ACTIVE_TAB(state, id) {
            state.pageView.activeTab = id;
        },
        REINDEX_TABS(state) {
            let i=0;
            state.pageView.tabs.forEach(item => {
                item.index = i;
                i++;
            });
        },
        CLOSE_TAB(state, index) {
            state.pageView.tabs.splice(index, 1);
        },
        CLEAR_TABS(state) {
            state.pageView.tabs = [];
        },
    },

    actions: {
        openNewTab({ commit, state }, tab) {
            commit('NEW_TAB', tab);
        },
    },
};
